import React from 'react';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { FaSignInAlt } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/Header.css';

const LOGO_URL = 'https://www.fluvialnet.com/wpFV/wp-content/uploads/2024/04/cropped-fluvialnet_logo.png';

// Reprend le menu principal de la home WordPress (Apparence > Menus) : à garder synchronisé.
// « Se connecter » ouvre une fenêtre sur les pages WordPress ; ici on renvoie vers la page de connexion.
const LOGIN_URL = 'https://www.fluvialnet.com/account/login/?redirect=https%3A%2F%2Fwww.fluvialnet.com%2Ffluviacap%2F';

const MENU = [
  {
    label: 'Le Mag’',
    items: [
      { label: 'Actualités', href: '/blog/' },
      { label: 'Sondage', href: 'https://docs.google.com/forms/d/e/1FAIpQLSfvfN72jjdbebAkNhPZK3iNUnZLrY-i0RJVx_TrBwql2zniyA/viewform' },
      { label: 'Archives du Mag’', href: '/compte/' },
    ],
  },
  {
    label: 'Guide du marinier',
    items: [
      { label: 'Annuaire', href: '/adresses-utiles' },
      { label: 'FLUVIACAP, le GPS fluvial', href: 'https://www.fluvialnet.com/fluviacap/' },
      { label: 'Tutos / Conseils', href: '/tutos-conseils/' },
      { label: 'Vignette VNF (Péage de plaisance)', href: 'https://www.fluvialnet.com/vignette-vnf/' },
      { label: 'Réglementation', href: '/reglementation/' },
      { label: 'Permis', href: '/permis/' },
      { label: 'Vocabulaire du marinier', href: '/vocabulaire-marinier' },
    ],
  },
  {
    label: 'Communauté',
    items: [
      { label: 'Forum Facebook', href: 'https://www.facebook.com/groups/fluvial' },
      { label: 'Nos petites annonces', href: 'https://www.fluvialnet.com/annonces-bateaux/' },
      { label: 'Ajouter une annonce', href: 'https://www.fluvialnet.com/submit-listing/details/' },
    ],
  },
  { label: 'Location de bateaux sans permis', href: 'https://www.lescanalous.com/' },
  {
    label: 'Voies et Bateaux',
    items: [
      { label: 'Voies navigables', href: '/voies-navigables' },
      { label: 'Fiches bateaux', href: '/fiches-bateaux' },
      { label: 'Bases de location par région', href: '/location-bateaux' },
      { label: 'Chantier naval', href: '/chantier-naval' },
      { label: 'Entreprises d’accastillage', href: '/accastillage' },
    ],
  },
];

const Header = () => {
  return (
    <header className="fluvial-header">
      <div className="fluvial-header-top">
        <a className="fluvial-header-brand" href="https://www.fluvialnet.com/" aria-label="Fluvial Le magazine de la navigation fluviale">
          <img src={LOGO_URL} alt="Fluvial" width="200" height="48" />
        </a>
      </div>
      <Navbar expand="lg" variant="dark" className="fluvial-header-main">
        <Container fluid>
          <Navbar.Toggle aria-controls="fluvial-header-nav" className="ms-auto" />
          <Navbar.Collapse id="fluvial-header-nav">
            <Nav className="mx-auto">
              {MENU.map((entry) =>
                entry.items ? (
                  <NavDropdown key={entry.label} title={entry.label} id={`nav-${entry.label}`} renderMenuOnMount>
                    {entry.items.map((item) => (
                      <NavDropdown.Item key={item.label} href={item.href}>
                        {item.label}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                ) : (
                  <Nav.Link key={entry.label} href={entry.href}>
                    {entry.label}
                  </Nav.Link>
                )
              )}
              <Nav.Link href={LOGIN_URL} className="fluvial-header-login">
                <FaSignInAlt aria-hidden="true" /> Se connecter
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
